import React from "react";
import { useAuthenticatedImage } from "../../hooks/useAuthenticatedImage";
import { isProxyUrl } from "../../util/imageUtils";

/**
 * Image component that loads images with authentication
 *
 * @param {Object} props
 * @param {string} props.src - Authenticated image URL (proxy URL)
 * @param {string} props.fallback - Fallback image for loading/error states
 * @param {string} props.alt - Alt text
 * @param {string} props.className - CSS class
 * @param {Object} props.style - Inline styles
 */
export function AuthImage({
  src: imageUrl,
  fallback,
  alt = "",
  className = "",
  style = {},
  ...props
}) {
  const { src, loading } = useAuthenticatedImage(imageUrl, fallback);

  // Never pass proxy URLs directly to <img src>, browser will omit auth header.
  if (!src || isProxyUrl(src)) {

    if (loading) {
      return (
        <div
          className={className}
          style={{
            ...style,
            opacity: 0.5,
          }}
        />
      );
    }

    if (fallback && !isProxyUrl(fallback)) {
      return <img src={fallback} alt={alt} className={className} style={style} {...props} />;
    }

    return null;
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{
        ...style,
        opacity: loading ? 0.5 : 1,
        transition: "opacity 0.2s ease-in-out",
      }}
      {...props}
    />
  );
}

export default AuthImage;

